import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import * as resources from './resources'

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    authReducer: resources.auth.reducer,
    sessionReducer: resources.session.reducer,
    modalReducer: resources.modal.reducer,
    menuReducer: resources.menu.reducer,
    profileReducer: resources.profile.reducer,
    usersReducer: resources.users.reducer,
    meReducer: resources.me.reducer,
    alertsReducer: resources.alerts.reducer,
    extractReducer: resources.extract.reducer,
    walletReducer: resources.wallet.reducer,
    searchReducer: resources.search.reducer,
    knowledgeBaseReducer: resources.knowledgeBase.reducer,
    timelineReducer: resources.timeline.reducer,
    filtersReducer: resources.filters.reducer,
    currentUserReducer: resources.currentUser.reducer,
    supervisedReducer: resources.supervised.reducer
  })

export default createRootReducer
